export const environment = {
    production: true,
    runServiceWorker: false,
    restApi: {
      msB2C: "https://apiqa.argosone.com/qa/adm/b2c/",
    },
    urlsGraphQL: {
      urlGraphQLAccounts: 'https://apiqa.argosone.com/qa/adm/accounts/',
      urlGraphQLGeneral: "https://apiqa.argosone.com/qa/adm/general/",
      content: "https://apiqa.argosone.com/qa/adm/content/",
      back_office: 'https://apiqa.argosone.com/qa/col/sto/back-office/'
    },
    backgroundImage:"https://stargosone2gqacol.argosone.com/argosone2g/bannersStore/loginBanner.png",
    DefaultRedirect:"https://colombiaqa2.argosone.com/",
    EncryptKey :"1203199320052021",
    recaptchaSiteKey:"6LdabjEqAAAAAPqFCf0UTwcrNwcNlOL18WitXcBB",
    tenantId :"Republica",
    storeId:"ff6f1e0d-fbad-4cdb-9cb8-39ef6984f8f5",
    x_token: 'cc330a4499e2448cb43190d5ee066aab',
    storeIdComplete:"ff6f1e0d-fbad-4cdb-9cb8-39ef6984f8f5",
    country:"COL"
  };

